const quickLinks = [
  { href: "#trend", label: "实时热搜" },
  { href: "#overview", label: "风评总览" },
  { href: "#focus", label: "争议焦点" },
  { href: "#comments", label: "评论区热评" },
  { href: "#timeline", label: "风评时间线" },
  { href: "#vote", label: "围观小调查" },
  { href: "#faq", label: "常见问题" },
  { href: "#subscribe", label: "订阅快报" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.2fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-eye-2-line text-xl" aria-hidden="true" />
              </span>
              <span className="leading-none">
                <span className="font-heading block text-xl font-bold text-background-50">哇偶围观站</span>
                <span className="font-bebas mt-1 block text-[11px] tracking-widest text-accent-300">WAOU ROUNDUP</span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-7 text-background-100/80">
              围绕哇偶姐姐的网络风评、争议焦点与热搜话题的围观集散地。汇总各平台吐槽、热评与风向，
              帮你快速判断大众的真实看法，理性吃瓜，不迷路。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">快捷围观</h3>
            <div className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3">
              {quickLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-background-100/80 transition-colors hover:text-accent-300"
                >
                  <i className="ri-arrow-right-s-line text-accent-400" aria-hidden="true" />
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-xl bg-background-50/5 p-5 text-xs leading-6 text-background-100/70">
          <p className="flex items-start gap-2">
            <i className="ri-shield-check-line mt-0.5 shrink-0 text-accent-300" aria-hidden="true" />
            <span>
              <strong className="text-background-100">内容说明与免责声明：</strong>
              本站内容均为各平台公开帖文、评论与网友观点的吃瓜式汇总与整理，仅用于呈现大众讨论趋势与评论区画风，
              不代表任何事实认定，也不构成对任何个人或组织的最终评价。热度、占比与数据为简化估算，仅供围观参考。
              请理性吃瓜、文明上网，切勿对任何人实施网络暴力。
            </span>
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/70">
            © 2026 哇偶围观站 · 全网风评，一页看懂
          </p>
          <p className="flex items-center gap-1.5 text-xs text-background-100/70">
            <i className="ri-flag-line text-accent-300" aria-hidden="true" />
            吃瓜有度 · 理性围观
          </p>
        </div>
      </div>
    </footer>
  );
}